import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const CategorySuppTickets = () => {
  return (
    <SettingsMetaData propertyName={"Category_Support_Tickets"} viewPropertyName={"Category"} />
  );
};
export default CategorySuppTickets;